import { LinkPaymentModel } from './LinkPaymentModel';

export interface ILinkPaymentSearchModel {
  name?: string;
  token?: string;
  status: number;
  buyer_name?: string;
  buyer_surname?: string;
  buyer_citizenship_number?: string;
  buyer_email?: string;
  buyer_phone_number?: string;
  page: number;
}

export class LinkPaymentSearchModelInit implements ILinkPaymentSearchModel {
  constructor(
    status: number = 0,
    page: number = 1,
  ) {
    this.status = status;
    this.page = page;
  }
  name?: string;
  token?: string;
  status: number;
  buyer_name?: string;
  buyer_surname?: string;
  buyer_citizenship_number?: string;
  buyer_email?: string;
  buyer_phone_number?: string;
  page: number;
}

export interface LinkPaymentSearchResponseModel {
  total_count: number;
  items: LinkPaymentModel[];
}